export const colors = {
  mainblue: "#0D1F22",
  ivory100: "#F5F9E9",
  pine: "#0B7A75",
  indianred: "#DB5461",
  marigold: "#ECA400",
  brown: "#8B6045",
  oliverhaze: "#8D8572",
  grey: "#A4A3A4",
  jumbo: "#737374",
  muddy: "#B88565",
  nightblue: "#3F3D56",
  night: "#2F2E41",
  beige100: "#EAE1CD",
  beige200: "#D9D4CA",
  ivory200: "#818C85",
};
